import {
  Avatar,
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";

const ViewTaskModal = ({ task, isOpen, onClose }) => {
  if (!task) return null;

  console.log("selectedTask", task)

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          bg="gray.700"
          color="white"
          p={2}
          px={4}
        >
          Task
          <HStack spacing={4}>
            <HStack spacing={1} alignItems={"center"}>
              <Text fontSize="xl">🗓️ </Text>

              <Text fontSize="xs">
                {task.dueDate
                  ? new Date(task.dueDate).toLocaleDateString()
                  : "N/A"}
              </Text>
            </HStack>
            <HStack alignItems="center" spacing={2}>
              <Avatar name={task.assignedTo || "Not Assigned"} size="sm" />
              <Text fontSize="xs">{task.assignedTo || "Not Assigned"}</Text>
            </HStack>
          </HStack>
        </ModalHeader>

        <ModalBody p={4}>
          <Text fontSize="sm" fontWeight="bold" mt={2}>
            Title:
          </Text>
          <Text fontSize="sm" mb={4}>
            {task.name}
          </Text>

          <Text fontSize="sm" fontWeight="bold" mt={2}>
            Description:
          </Text>
          {/* <Divider my={1} /> */}
          <Text fontSize="sm" mb={4}>
            {task.taskDesc?.trim() ? task.taskDesc : task.detail}
          </Text>

          {task.screenshots?.length > 0 && (
            <Box mb={4}>
              <Text fontSize="sm" fontWeight="bold">
                Screenshots:
              </Text>
              <HStack spacing={3} flexWrap="wrap">
                {task.screenshots.map((file, i) => {
                  const src =
                    typeof file === "string" ? file : URL.createObjectURL(file);
                  return (
                    <Box key={i} boxSize="80px">
                      <a href={src} target="_blank" rel="noopener noreferrer">
                        <img
                          src={src}
                          alt={`Screenshot ${i + 1}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                        />
                      </a>
                    </Box>
                  );
                })}
              </HStack>
            </Box>
          )}
        </ModalBody>

        <ModalFooter>
          <Button size="sm" colorScheme="blue" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ViewTaskModal;
